import React, { useState } from 'react';
import Hero from '../components/Build/Hero';
import HowItWorks from '../components/Build/HowItWorks';
import Monetize from '../components/Build/Monetize';
import Brochure from '../components/Shared/Brochure';
import PopupForm from '../components/Build/PopupForm';

const Build = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  return (
    <div>
      <div onClick={() => setIsPopupOpen(true)} className='bg-[#f3f4f6] text-center cursor-pointer text-[12px] md:text-[14px] lg:text-[16px] text-[#1b1b1b] font-semibold py-3 md:py-4'>
        <p className='px-4 flex items-center justify-center'>Click here & let us call you at a Convenient time</p>
        <p className='flex items-center justify-center'>
          <img src="/icons/clock.svg" alt="icon" className='h-4 mr-1' /> {" "} 30 seconds to schedule
        </p>
      </div>
      <Hero />
      <HowItWorks />
      <Monetize />
      <Brochure />

      <PopupForm
        isOpen={isPopupOpen} 
        onClose={() => setIsPopupOpen(false)} 
      />
    </div>
  );
};

export default Build;
